import serviceIns from "./basic/requestIns"

export const homePage = data => {
  return serviceIns.request({
    url: '/wechat/official_website/home/page',
    method: 'post',
    data
  })
}

export const newsList = data => {
  return serviceIns.request({
    url: '/wechat/official_website/news/list',
    method: 'post',
    data
  })
}

export const configQuery = data => {
  return serviceIns.request({
    url: '/wechat/official_website/config/query',
    method: 'post',
    data
  })
}

export const newsDetail = data => {
  return serviceIns.request({
    url: '/wechat/official_website/news/detail',
    method: 'post',
    data
  })
}

export const applicationSave = data => {
  return serviceIns.request({
    url: '/wechat/official_website/join_application/save',
    method: 'post',
    data
  })
}

export const giftDetail = data => {
  return serviceIns.request({
    url: '/wechat/official_website/ip_gift/detail',
    method: 'post',
    data
  })
}
